import { useEffect } from 'react';
import { Alert, Form, Modal } from 'antd';
import { ProFormTextArea } from '@ant-design/pro-components';
import type { ReversalListItem } from './api';

// Điểm là numeric(18,4) từ server (vd 45.0000). Định dạng bỏ số 0 thừa: "45", "45,5".
const POINTS = new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2 });

interface Props {
  item: ReversalListItem | null;
  submitting: boolean;
  onSubmit: (note: string) => void;
  onCancel: () => void;
}

export function RejectReversalModal({ item, submitting, onSubmit, onCancel }: Props) {
  const [form] = Form.useForm<{ note: string }>();

  useEffect(() => {
    if (item) form.setFieldsValue({ note: '' });
  }, [item, form]);

  return (
    <Modal
      open={item !== null}
      title={item ? `Từ chối đảo điểm ${item.memberCode}` : ''}
      okText="Từ chối"
      okButtonProps={{ danger: true }}
      cancelText="Hủy"
      confirmLoading={submitting}
      onCancel={onCancel}
      destroyOnHidden
      onOk={() => {
        form
          .validateFields()
          .then((values) => onSubmit(values.note.trim()))
          .catch(() => {});
      }}
    >
      {item && (
        <>
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
            message="Điểm khách giữ nguyên"
            description={`Yêu cầu hoàn ${POINTS.format(item.spendablePoints)} điểm sẽ bị đóng. Người xin cần biết vì sao.`}
          />
          <Form form={form} layout="vertical" requiredMark={false}>
            <ProFormTextArea
              name="note"
              label="Lý do từ chối"
              placeholder="Hóa đơn đã đối chiếu với POS, không hủy."
              rules={[
                { required: true, message: 'Từ chối thì phải ghi lý do.' },
                { max: 500, message: 'Lý do quá dài.' },
              ]}
              fieldProps={{ rows: 3 }}
            />
          </Form>
        </>
      )}
    </Modal>
  );
}
